<div class="bg-forest height-100">
    <compliance-login-header></compliance-login-header>
    <compliance-login-form (loginEmitter)="connection($event)" (forgotPasswordEmitter)="forgotPassword($event)"></compliance-login-form>
    <compliance-footer [backAdress]="null"></compliance-footer>
</div>
